import React from 'react';

type ExternalLinkProps = React.AnchorHTMLAttributes<HTMLAnchorElement> & {};

const ExternalLink: React.FC<ExternalLinkProps> = ({ href, rel = 'noreferrer noopener', children, ...rest }) => {
    if (href && !/(^https?:\/\/)|(^\/)/gi.test(href)) {
        href = 'http://' + href;
    }

    return (
        <a rel={rel} href={href} {...rest}>
            {children}
        </a>
    );
};

export default ExternalLink;
